import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportCameraTrapsResponse } from "./type";

export async function exportCameraTraps(): Promise<ExportCameraTrapsResponse> {
  const response = await apiClient.get<ExportCameraTrapsResponse>(
    apiPaths.devices.cameraTraps.export,
  );

  return response.data;
}
